import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";

export const ActualizarInmuebles = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idinmuebles: "",
    descripcion: "",
    estado: "",
    municipio: "",
    ciudad: "",
    direccion: "",
  });
  const [estado, setEstado] = useState();
  const [ciudad, setCiudad] = useState();
  const [muni, setMuni] = useState();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtDescrip = useRef();
  const txtDireccion = useRef();
  const txtEstado = useRef();
  const txtMunicipio = useRef();
  const txtCiudad = useRef();

  const onChange = (event) => {
    if (event.target.name === "estado" && event.target.value !== "") {
      seleccionarMunicipio(event.target.value.trim());
      seleccionarCiudad();
    }

    if (event.target.name === "municipio" && event.target.value !== "") {
      seleccionarCiudad(event.target.value.trim());
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Inmueble",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtEstado.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estado",
        icono: "informacion",
      });
      sigue = false;
      txtEstado.current.focus();
    } else if (txtMunicipio.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Municipio",
        icono: "informacion",
      });
      sigue = false;
      txtMunicipio.current.focus();
    } else if (txtCiudad.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione la Ciudad",
        icono: "informacion",
      });
      sigue = false;
      txtCiudad.current.focus();
    } else if (txtDireccion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Dirección del Inmueble no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDireccion.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/rentas/actualizarinmuebles/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtIdd.current.value),
      descr: txtDescrip.current.value.trim(),
      est: txtEstado.current.value,
      muni: txtMunicipio.current.value,
      ciu: txtCiudad.current.value,
      dire: txtDireccion.current.value.trim(),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const blanquear = () => {
    setValues({
      idinmuebles: "",
      descripcion: "",
      estado: "",
      municipio: "",
      ciudad: "",
      direccion: "",
    });
    setMuni();
    setCiudad();
    setEstado();
    setActivate(false);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
  };

  const selectEstado = () => {
    let campos = "idestado, trim(nombre) as nombre";
    let nomtab = "estado";
    let orden = "idestado";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setEstado(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMunicipio = (id) => {
    let campos = "idmunicipio, idestado, trim(nombre) as nombre";
    let nomtab = "municipio";
    let nomid = "idestado";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMuni(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarCiudad = (id) => {
    let campos = "idmunicipio, idciudad, trim(nombre) as nombre";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setCiudad(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        selectEstado();
        if (props.operacion !== 1) {
          setValues(props.inmuebles);
          setEstado(props.estado);
          setMuni(props.municipio);
          setCiudad(props.ciudad);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Agregar Inmueble."
              : operacion === 2
              ? "Editar Inmueble."
              : operacion === 3
              ? "Eliminar Inmueble."
              : "Consultar Inmueble."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} />
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="container row m-0">
                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    ref={txtIdd}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={values ? values.idinmuebles.trim() : ""}
                    id="inputCedula"
                  />
                </div>
              </div>

              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto col-sm-12">
                <legend className="float-none m-0 w-auto">
                  Datos Generales
                </legend>

                <div className="input-group py-1 input-group-sm col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Descripción:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control text-uppercase"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtDescrip}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={values ? values.descripcion.trim() : ""}
                    id="inputDireccion"
                  />
                </div>

                <div className="col-sm-4 py-1 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Estado:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtEstado}
                      className="form-select text-center"
                      id="inputStatus"
                      name="estado"
                      onChange={onChange}
                      value={values ? values.estado.trim() : ""}
                    >
                      <option value="">----Seleccione---</option>
                      {estado &&
                        estado.map((item, index) => (
                          <option key={index} value={item.idestado}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-sm-4 py-1 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Municipio:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtMunicipio}
                      className="form-select text-center"
                      id="inputStatus"
                      name="municipio"
                      onChange={onChange}
                      value={values ? values.municipio.trim() : ""}
                    >
                      <option value="">---Seleccione---</option>
                      {muni &&
                        muni.map((item, index) => (
                          <option key={index} value={item.idmunicipio}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-sm-4 py-1 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text px-1"
                      id="inputGroup-sizing-sm"
                    >
                      Ciudad:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtCiudad}
                      className="form-select text-center"
                      id="inputStatus"
                      name="ciudad"
                      onChange={onChange}
                      value={values ? values.ciudad.trim() : ""}
                    >
                      <option value="">---Seleccione---</option>
                      {ciudad &&
                        ciudad.map((item, index) => (
                          <option key={index} value={item.idciudad}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="input-group py-1 input-group-sm col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Dirección:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control text-uppercase"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtDireccion}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={values ? values.direccion.trim() : ""}
                    id="inputDireccion"
                  />
                </div>
              </fieldset>

              <div className="col-md-12 py-2"></div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/rentas/modalActualizarInmuebles.js